var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 931.196,
    height: 163.823,
    viewBox: "0 0 931.196 163.823",
    className: "entourer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Trac\\xE9_19",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2,
    transform: "translate(-11432 -4992.18)",
    d: "M 11854.4 4994.67 s -424.533 -18.134 -421.333 72.533 S 11893 5138.67 11893 5138.67 s 477.665 12.8 469.133 -71.467 s -564.266 -51.2 -564.266 -51.2",
    "data-name": "Trac\\xE9 19",
    className: "BkJOtYoY_0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.dda782e317d4a6c71371cc948752b088.svg";
export { ForwardRef as ReactComponent };